exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".supercharged-entertainment-container .claim-card,\n.supercharged-entertainment-container .confirm {\n  background: none;\n}\n.supercharged-entertainment-container .btn-link {\n  border: 0;\n  padding: 0;\n}", ""]);

// exports
